var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EBF0FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 10.6667C12.666 10.6667 9.81935 12.74 8.66602 15.6667C9.81935 18.5934 12.666 20.6667 15.9993 20.6667C19.3327 20.6667 22.1793 18.5934 23.3327 15.6667C22.1793 12.74 19.3327 10.6667 15.9993 10.6667ZM15.9993 19C14.1593 19 12.666 17.5067 12.666 15.6667C12.666 13.8267 14.1593 12.3334 15.9993 12.3334C17.8393 12.3334 19.3327 13.8267 19.3327 15.6667C19.3327 17.5067 17.8393 19 15.9993 19ZM15.9993 13.6667C14.8927 13.6667 13.9993 14.56 13.9993 15.6667C13.9993 16.7734 14.8927 17.6667 15.9993 17.6667C17.106 17.6667 17.9993 16.7734 17.9993 15.6667C17.9993 14.56 17.106 13.6667 15.9993 13.6667Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.b52a9494.svg";
export { ForwardRef as ReactComponent };